export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'grdPriznaky';
export const NAME = 'TypPneu';
